"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.itemDeleting = itemDeleting;
exports.itemFailure = itemFailure;
exports.itemLoading = itemLoading;
exports.itemRefreshing = itemRefreshing;
exports.itemStatus = itemStatus;
exports.itemUpdating = itemUpdating;
exports.itemsDeleting = itemsDeleting;
exports.itemsFailure = itemsFailure;
exports.itemsLoading = itemsLoading;
exports.itemsUpdating = itemsUpdating;
exports.listFailure = listFailure;
exports.listFetching = listFetching;
exports.listLoading = listLoading;
exports.listRefreshing = listRefreshing;
exports.listStatus = listStatus;

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _entityNormalizer = require("@rexlabs/entity-normalizer");

var _lodash = _interopRequireDefault(require("lodash"));

var _invariant = _interopRequireDefault(require("invariant"));

/**
 * Change the status state of a list
 * @param  {Object} state
 * @param  {String|int} id
 * @param  {String} status
 * @return {Object}
 */
function listStatus(state, id, status) {
  return (0, _entityNormalizer.setEntityListStatus)(state, id, status);
}
/**
 * Alias: listStatus(state, action.payload.id, STATUS_LOADING)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function listLoading(state, action) {
  var id = action.payload.id;
  (0, _invariant.default)(id, 'You need to define the ID of the list');
  return listStatus(state, id, _entityNormalizer.STATUS_LOADING);
}
/**
 * Alias: listStatus(state, action.payload.id, STATUS_FETCHING)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function listFetching(state, action) {
  var _action$payload = action.payload,
      id = _action$payload.id,
      isRefreshing = _action$payload.isRefreshing;
  (0, _invariant.default)(id, 'You need to define the ID of the list');
  return isRefreshing ? state : listStatus(state, id, _entityNormalizer.STATUS_FETCHING);
}
/**
 * Alias: listStatus(state, action.payload.id, STATUS_REFRESHING)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function listRefreshing(state, action) {
  var id = action.payload.id;
  (0, _invariant.default)(id, 'You need to define the ID of the list');
  return listStatus(state, id, _entityNormalizer.STATUS_REFRESHING);
}
/**
 * Set error state and message for given list
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function listFailure(state, action) {
  var _action$meta$original = action.meta.originalPayload,
      id = _action$meta$original.id,
      uuid = _action$meta$original.uuid;
  var error = action.payload.error;
  (0, _invariant.default)(id, 'You need to define the ID  of the list that failed!'); // Set error ...

  var newState = (0, _entityNormalizer.setEntityListError)(state, id, error);
  newState = (0, _entityNormalizer.addListConsumer)(newState, id, uuid); // ...and list status

  return listStatus(newState, id, _entityNormalizer.STATUS_ERROR);
}
/**
 * Update item status state
 * @param  {Object} state
 * @param  {String|int} id
 * @param  {String} status
 * @return {Object}
 */


function itemStatus(state, id, status) {
  return (0, _entityNormalizer.setEntityItemStatus)(state, id, status);
}
/**
 * Set item status to loading (or fetching if it already has been loaded!)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemLoading(state, action) {
  var id = action.payload.id;
  (0, _invariant.default)(id, 'You need to define the ID of the item');
  var currStatus = (0, _entityNormalizer.getEntityItemStatus)(state, id);
  var newStatus = _entityNormalizer.STATUS_LOADING;

  if (currStatus === _entityNormalizer.STATUS_LOADED) {
    // If we are just fetching more data to get additional information
    // we want to set the status to `fetching` rather than `loading`
    newStatus = _entityNormalizer.STATUS_FETCHING;
  }

  return itemStatus(state, id, newStatus);
}
/**
 * Alias: itemStatus(state, action.payload.id, STATUS_REFRESHING)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemRefreshing(state, action) {
  var id = action.payload.id;
  return itemStatus(state, id, _entityNormalizer.STATUS_REFRESHING);
}
/**
 * Alias: itemStatus(state, action.payload.id, STATUS_UPDATING)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemUpdating(state, action) {
  var id = action.payload.id;
  return itemStatus(state, id, _entityNormalizer.STATUS_UPDATING);
}
/**
 * Alias: itemStatus(state, action.payload.id, STATUS_DELETING)
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemDeleting(state, action) {
  var id = action.payload.id;
  return itemStatus(state, id, _entityNormalizer.STATUS_DELETING);
}
/**
 * Setting item error message and status state
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemFailure(state, action) {
  var _action$meta$original2 = action.meta.originalPayload,
      id = _action$meta$original2.id,
      uuid = _action$meta$original2.uuid;
  var error = action.payload.error;
  (0, _invariant.default)(id, 'You need to defined the ID of the item that failed');
  var newState = (0, _entityNormalizer.setEntityItemError)(state, id, error);
  newState = (0, _entityNormalizer.addItemConsumer)(newState, id, uuid);
  return itemStatus(newState, id, _entityNormalizer.STATUS_ERROR);
}
/**
 * Bulk action for multiple items to status STATUS_LOADING
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemsLoading(state, action) {
  var items = action.payload.items;
  (0, _invariant.default)(items && _lodash.default.isArray(items), 'You need to pass in the array of items');
  (0, _forEach.default)(items).call(items, function (item) {
    state = itemStatus(state, item.id, _entityNormalizer.STATUS_LOADING);
  });
  return state;
}
/**
 * Bulk action for multiple items to status STATUS_UPDATING
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemsUpdating(state, action) {
  var items = action.payload.items;
  (0, _invariant.default)(items && _lodash.default.isArray(items), 'You need to pass in the array of items');
  (0, _forEach.default)(items).call(items, function (item) {
    state = itemStatus(state, item.id, _entityNormalizer.STATUS_UPDATING);
  });
  return state;
}
/**
 * Bulk action for multiple items to status STATUS_DELETING
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemsDeleting(state, action) {
  var items = action.payload.items;
  (0, _invariant.default)(items && _lodash.default.isArray(items), 'You need to pass in the array of items');
  (0, _forEach.default)(items).call(items, function (item) {
    state = itemStatus(state, item.id, _entityNormalizer.STATUS_DELETING);
  });
  return state;
}
/**
 * Bulk action for multiple items to status STATUS_ERROR and saving the
 * error messages
 * @param  {Object} state
 * @param  {Object} action
 * @return {Object}
 */


function itemsFailure(state, action) {
  var _action$payload2 = action.payload,
      items = _action$payload2.items,
      error = _action$payload2.error;
  (0, _invariant.default)(items && _lodash.default.isArray(items), 'You need to pass in the array of items');
  (0, _forEach.default)(items).call(items, function (item) {
    var newState = (0, _entityNormalizer.setEntityItemError)(state, item.id, error);
    state = itemStatus(newState, item.id, _entityNormalizer.STATUS_ERROR);
  });
  return state;
}